import types from '../types'
import apiCaller from '../../utils/apiCaller'
import Vue from 'vue'

const state = {
    list: [],
    details: [{
        "analysisGroupList": [
          {
            "disease": "string",
            "factors": [
              {
                "factor": "string",
                "value": 0,
                "valueGroupAvg": 0
              }
            ]
          }
        ],
        "analysisMultivariateList": [
          {
            "disease": "string",
            "riskFactors": [
              {
                "changeRiskRate": 0,
                "convertValue": 0,
                "factor": "string"
              }
            ],
            "riskIndexTotal": 0,
            "riskIntervals": [
              0
            ],
            "riskRateTotal": 0
          }
        ],
        "deathRate": {
          "age": 0,
          "birthrateLevel": "string",
          "gender": "string",
          "period": 0,
          "periodArray": [
            0
          ],
          "rate": 0,
          "validAge": true,
          "validBirthrateLevel": true,
          "validGender": true,
          "year": "string"
        },
        "population": {
          "age": 0,
          "birthrateLevel": "string",
          "count": 0,
          "gender": "string",
          "validAge": true,
          "validGender": true,
          "year": "string"
        },
        "predictDeath": {
          "checkupNo": 0,
          "score": 0,
          "statistics": 0
        },
        "predictDisease": {
          "breastIndex": 0,
          "checkupNo": 0,
          "colorectalIndex": 0,
          "dementiaIndex": 0,
          "displayAge": "20세",
          "displayBirthday": "2000.01.01",
          "displayCheckupDate": "2020.03.03",
          "displayGender": "남",
          "dmIndex": 1,
          "gender": "2",
          "heartIndex": 0,
          "liverIndex": 0,
          "lungIndex": 0,
          "name": "홍길동",
          "prostateIndex": 0,
          "stomachIndex": 0,
          "strokeIndex": 0,
          "topDisease": "당뇨",
          "topRank": 97,
          "topRiskIndex": 0
        },
        "predictHealthAge": {
          "age": 0,
          "ageReal": 0,
          "checkupNo": 0,
          "date": "string"
        }
      }]
}

const mutations = {
    [types.report.mutations.list] (state, { list }) {
        const target = state.list
        target.splice(0, target.length)
        target.push(...list.sort((a, b) => b.checkupNo - a.checkupNo))
    },
    [types.report.mutations.detail] (state, { checkupNo, detail }) {
        Vue.set(state.details, checkupNo, detail)
    }
}

const actions = {
    async [types.report.actions.fetchList] ({ commit }, { authToken }) {
        const res = await apiCaller.report.list({ authToken })

        if (res.error === null) {
            const list = res.data
            commit(types.report.mutations.list, { list })
            return true
        } else {
            return false
        }
    },
    async [types.report.actions.fetchDetail] ({ commit }, { authToken, checkupNo }) {
        const res = await apiCaller.report.detail({ authToken, checkupNo })

        if (res.error === null) {
            const detail = res.data
            commit(types.report.mutations.detail, { checkupNo, detail })
            return true
        } else {
            return false
        }
    }
}

const getters = {
    [types.report.getters.list]: state => state.list || [],
    [types.report.getters.info]: state => checkupNo => state.list.find(item => item.checkupNo === checkupNo) || null,
    [types.report.getters.detail]: state => checkupNo => state.details[checkupNo] || null
}

export default {
    state,
    mutations,
    actions,
    getters
}
